tinymce.addI18n("it", {
    "#": "#",
    "Accessibility": "Accessibilit\xe0",
    "Accordion": "Accordion",
    "Accordion body...": "Accordion body...",
    "Accordion summary...": "Accordion summary...",
    "Action": "Azione",
    "Activity": "Attivit\xe0",
    "Address": "Indirizzo",
    "Advanced": "Avanzate",
    "Align": "Allinea",
    "Align center": "Allinea al centro",
    "Align left": "Allinea a sinistra",
    "Align right": "Allinea a destra",
    "Alignment": "Allineamento",
    "Alignment {0}": "Alignment {0}",
    "All": "Tutto",
    "Alternative description": "Descrizione alternativa",
    "Alternative source": "Sorgente alternativa",
    "Alternative source URL": "URL sorgente alternativa",
    "Anchor": "Ancora",
    "Anchor...": "Ancoraggio...",
    "Anchors": "Ancoraggi",
    "Animals and Nature": "Animali e natura",
    "Arrows": "Frecce",
    "B": "B",
    "Background color": "Colore dello sfondo",
    "Background color {0}": "Colore dello sfondo {0}",
    "Black": "Nero",
    "Block": "Blocco",
    "Block {0}": "Block {0}",
    "Blockquote": "Citazione",
    "Blocks": "Blocchi",
    "Blue": "Blu",
    "Blue component": "Componente blu",
    "Body": "Corpo",
    "Bold": "Grassetto",
    "Border": "Bordo",
    "Border color": "Colore del bordo",
    "Border style": "Stile del bordo",
    "Border width": "Larghezza del bordo",
    "Bottom": "In basso",
    "Browse files": "Esplora i file",
    "Browse for an image": "Cerca un'immagine",
    "Browse links": "Esplora i collegamenti",
    "Bullet list": "Elenco puntato",
    "Cancel": "Annulla",
    "Caption": "Didascalia",
    "Cell": "Cella",
    "Cell padding": "Spaziatura interna celle",
    "Cell properties": "Propriet\xe0 cella",
    "Cell spacing": "Spaziatura tra celle",
    "Cell styles": "Stili cella",
    "Cell type": "Tipo di cella",
    "Center": "Centro",
    "Characters": "Caratteri",
    "Characters (no spaces)": "Caratteri (senza spazi)",
    "Circle": "Circolo",
    "Class": "Classe",
    "Clear formatting": "Cancella la formattazione",
    "Close": "Chiudi",
    "Code": "Codice",
    "Code sample...": "Esempio di codice...",
    "Code view": "Visualizza codice",
    "Color Picker": "Selettore di colori",
    "Color swatch": "Campione di colore",
    "Cols": "Colonne",
    "Column": "Colonna",
    "Column clipboard actions": "Azioni appunti colonna",
    "Column group": "Gruppo di colonne",
    "Column header": "Intestazione colonna",
    "Constrain proportions": "Mantieni proporzioni",
    "Copy": "Copia",
    "Copy column": "Copia colonna",
    "Copy row": "Copia riga",
    "Could not find the specified string.": "Impossibile trovare la stringa specificata.",
    "Could not load emojis": "Non posso caricare le emojis",
    "Count": "Conteggio",
    "Currency": "Valuta",
    "Current window": "Finestra corrente",
    "Custom color": "Colore personalizzato",
    "Custom...": "Personalizzato...",
    "Cut": "Taglia",
    "Cut column": "Taglia colonna",
    "Cut row": "Taglia riga",
    "Dark Blue": "Blu scuro",
    "Dark Gray": "Grigio scuro",
    "Dark Green": "Verde scuro",
    "Dark Orange": "Arancio scuro",
    "Dark Purple": "Viola scuro",
    "Dark Red": "Rosso scuro",
    "Dark Turquoise": "Turchese scuro",
    "Dark Yellow": "Giallo scuro",
    "Dashed": "Trattini",
    "Date/time": "Data/ora",
    "Decrease indent": "Riduci rientro",
    "Default": "Predefinito",
    "Delete accordion": "Delete accordion",
    "Delete column": "Elimina colonna",
    "Delete row": "Elimina riga",
    "Delete table": "Elimina tabella",
    "Dimensions": "Dimensioni",
    "Disc": "Disco",
    "Div": "Div",
    "Document": "Documento",
    "Dotted": "Puntini",
    "Double": "Doppio",
    "Drop an image here": "Rilasciare un'immagine qui",
    "Dropped file type is not supported": "Tipo di file non supportato",
    "Edit": "Modifica",
    "Embed": "Incorpora",
    "Emojis": "Emojis",
    "Emojis...": "Emojis...",
    "Error": "Errore",
    "Error: Form submit field collision.": "Errore: Conflitto di campi nel modulo inviato.",
    "Error: No form element found.": "Errore: Nessun elemento di modulo trovato.",
    "Extended Latin": "Latino esteso",
    "Failed to initialize plugin: {0}": "Inizializzazione plugin fallita: {0}",
    "Failed to load plugin url: {0}": "Caricamento URL plugin fallito: {0}",
    "Failed to load plugin: {0} from url {1}": "Caricamento plugin fallito: {0} dall'URL {1}",
    "Failed to upload image: {0}": "Caricamento immagine fallito: {0}",
    "File": "File",
    "Find": "Trova",
    "Find (if searchreplace plugin activated)": "Trova (se \xe8 attivato l'apposito plugin)",
    "Find and Replace": "Trova e sostituisci",
    "Find and replace...": "Trova e sostituisci...",
    "Find in selection": "Trova nella selezione",
    "Find whole words only": "Trova solo parole intere",
    "Flags": "Bandiere",
    "Focus to contextual toolbar": "Imposta stato attivo per la barra degli strumenti contestuale",
    "Focus to element path": "Imposta stato attivo per il percorso dell'elemento",
    "Focus to menubar": "Imposta stato attivo per la barra dei menu",
    "Focus to toolbar": "Imposta stato attivo per la barra degli strumenti",
    "Font": "Carattere",
    "Font size {0}": "Font size {0}",
    "Font sizes": "Dimensioni font",
    "Font {0}": "Font {0}",
    "Fonts": "Caratteri",
    "Food and Drink": "Cibi e bevande",
    "Footer": "Pi\xe8 di pagina",
    "Format": "Formato",
    "Format {0}": "Format {0}",
    "Formats": "Formati",
    "Fullscreen": "A tutto schermo",
    "G": "V",
    "General": "Generali",
    "Gray": "Grigio",
    "Green": "Verde",
    "Green component": "Componente verde",
    "Groove": "Groove",
    "Handy Shortcuts": "Scorciatoie utili",
    "Header": "Intestazione",
    "Header cell": "Cella d'intestazione",
    "Heading 1": "Titolo 1",
    "Heading 2": "Titolo 2",
    "Heading 3": "Titolo 3",
    "Heading 4": "Titolo 4",
    "Heading 5": "Titolo 5",
    "Heading 6": "Titolo 6",
    "Headings": "Titoli",
    "Height": "Altezza",
    "Help": "Guida",
    "Hex color code": "Codice esadecimale del colore",
    "Hidden": "Nascosto",
    "Horizontal align": "Allineamento orizzontale",
    "Horizontal line": "Linea orizzontale",
    "Horizontal space": "Spazio orizzontale",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID dovrebbe iniziare con una lettera, seguita solo da lettere, numeri, trattini, punti, due punti.",
    "Image is decorative": "L'immagine \xe8 decorativa",
    "Image list": "Elenco immagini",
    "Image title": "Titolo immagine",
    "Image...": "Immagine...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Errore HTTP ImageProxy: impossibile trovare Image Proxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Errore HTTP ImageProxy: URL Image Proxy non corretto",
    "ImageProxy HTTP error: Rejected request": "Errore HTTP ImageProxy: richiesta rifiutata",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Errore HTTP ImageProxy: errore sconosciuto",
    "Increase indent": "Aumenta rientro",
    "Inline": "In linea",
    "Insert": "Inserisci",
    "Insert Template": "Inserisci modello",
    "Insert accordion": "Insert accordion",
    "Insert column after": "Inserisci colonna dopo",
    "Insert column before": "Inserisci colonna prima",
    "Insert date/time": "Inserisci data/ora",
    "Insert image": "Inserisci immagine",
    "Insert link (if link plugin activated)": "Inserisci un collegamento (se \xe8 attivato l'apposito plugin)",
    "Insert row after": "Inserisci riga dopo",
    "Insert row before": "Inserisci riga prima",
    "Insert table": "Inserisci tabella",
    "Insert template...": "Inserisci modello...",
    "Insert video": "Inserisci video",
    "Insert/Edit code sample": "Inserisci/modifica esempio di codice",
    "Insert/edit image": "Inserisci/modifica immagine",
    "Insert/edit link": "Inserisci/modifica collegamento",
    "Insert/edit media": "Inserisci/modifica oggetti multimediali",
    "Insert/edit video": "Inserisci/modifica video",
    "Inset": "Inserto",
    "Invalid hex color code: {0}": "Codice esadecimale del colore non valido: {0}",
    "Invalid input": "Dato non valido",
    "Italic": "Corsivo",
    "Justify": "Giustifica",
    "Keyboard Navigation": "Navigazione tramite tastiera",
    "Language": "Lingua",
    "Learn more...": "Maggiori informazioni...",
    "Left": "Sinistra",
    "Left to right": "Da sinistra a destra",
    "Light Blue": "Azzurro",
    "Light Gray": "Grigio chiaro",
    "Light Green": "Verde chiaro",
    "Light Purple": "Viola chiaro",
    "Light Red": "Rosso chiaro",
    "Light Yellow": "Giallo chiaro",
    "Line height": "Altezza linea",
    "Link list": "Elenco collegamenti",
    "Link...": "Collegamento...",
    "List Properties": "Propriet\xe0 Lista",
    "List properties...": "Propriet\xe0 lista...",
    "Loading emojis...": "Caricamento emojis...",
    "Loading...": "Lettura in corso...",
    "Lower Alpha": "Alfabetico minuscolo",
    "Lower Greek": "Greco minuscolo",
    "Lower Roman": "Romano minuscolo",
    "Match case": "Maiuscole/minuscole",
    "Mathematical": "Caratteri matematici",
    "Media poster (Image URL)": "Poster dell'oggetto multimediale (URL dell'immagine)",
    "Media...": "Oggetto multimediale...",
    "Medium Blue": "Blu medio",
    "Medium Gray": "Grigio medio",
    "Medium Purple": "Viola medio",
    "Merge cells": "Unisci le celle",
    "Middle": "Centrato",
    "Midnight Blue": "Blu notte",
    "More...": "Altro\u2026",
    "Name": "Nome",
    "Navy Blue": "Blu scuro",
    "New document": "Nuovo documento",
    "New window": "Nuova finestra",
    "Next": "Avanti",
    "No": "No",
    "No alignment": "Senza allineamento",
    "No color": "Nessun colore",
    "Nonbreaking space": "Spazio indivisibile",
    "None": "Nessuno",
    "Numbered list": "Elenco numerato",
    "OR": "OPPURE",
    "Objects": "Oggetti",
    "Ok": "Ok",
    "Open help dialog": "Apri la finestra di aiuto",
    "Open link": "Apri link",
    "Open link in...": "Apri collegamento in...",
    "Open popup menu for split buttons": "Apri il menu a comparsa per i pulsanti divisi",
    "Orange": "Arancio",
    "Outset": "Inizio",
    "Page break": "Interruzione di pagina",
    "Paragraph": "Paragrafo",
    "Paste": "Incolla",
    "Paste as text": "Incolla senza formattazioni",
    "Paste column after": "Inserisci colonna dopo",
    "Paste column before": "Inserisci colonna prima",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Incolla \xe8 in modalit\xe0 testo normale. I contenuti saranno incollati come testo normale se non viene disattivata questa opzione.",
    "Paste or type a link": "Incolla o digita un collegamento",
    "Paste row after": "Incolla riga dopo",
    "Paste row before": "Incolla riga prima",
    "Paste your embed code below:": "Incolla il codice d'incorporamento di seguito:",
    "People": "Persone",
    "Plugins": "Plugin",
    "Plugins installed ({0}):": "Plugin installati ({0}):",
    "Powered by {0}": "Con tecnologia {0}",
    "Pre": "Pre",
    "Preferences": "Preferenze",
    "Preformatted": "Preformattato",
    "Premium plugins:": "Plugin Premium:",
    "Press the Up and Down arrow keys to resize the editor.": "Premi le frecce in su e in gi\xf9 per ridimensionare l'editor.",
    "Press the arrow keys to resize the editor.": "Premi le frecce per ridimensionare l'editor.",
    "Press {0} for help": "Premi {0} per ricevere aiuto",
    "Preview": "Anteprima",
    "Previous": "Indietro",
    "Print": "Stampa",
    "Print...": "Stampa...",
    "Purple": "Viola",
    "Quotations": "Citazioni",
    "R": "R",
    "Range 0 to 255": "Intervallo da 0 a 255",
    "Red": "Rosso",
    "Red component": "Componente rosso",
    "Redo": "Redo",
    "Remove": "Rimuovi",
    "Remove color": "Rimuovi colore",
    "Remove link": "Rimuovi collegamento",
    "Replace": "Sostituisci",
    "Replace all": "Sostituisci tutto",
    "Replace with": "Sostituisci con",
    "Resize": "Ridimensiona",
    "Restore last draft": "Ripristina l'ultima bozza",
    "Reveal or hide additional toolbar items": "Mostra o nascondi componenti aggiuntivi",
    "Rich Text Area": "Area di testo ricco",
    "Rich Text Area. Press ALT-0 for help.": "Area di testo RTF. Premere ALT-0 per la guida.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Area di testo RTF. Premere ALT-F9 per il menu. Premere ALT-F10 per la barra degli strumenti. Premere ALT-0 per la guida.",
    "Ridge": "Ridge",
    "Right": "Destra",
    "Right to left": "Da destra a sinistra",
    "Row": "Riga",
    "Row clipboard actions": "Azioni appunti riga",
    "Row group": "Gruppo di righe",
    "Row header": "Intestazione riga",
    "Row properties": "Propriet\xe0 della riga",
    "Row type": "Tipo di riga",
    "Rows": "Righe",
    "Save": "Salva",
    "Save (if save plugin activated)": "Salva (se \xe8 attivato l'apposito plugin)",
    "Scope": "Ambito",
    "Search": "Cerca",
    "Select all": "Seleziona tutto",
    "Select...": "Seleziona...",
    "Selection": "Selezione",
    "Shortcut": "Collegamento",
    "Show blocks": "Mostra blocchi",
    "Show caption": "Mostra didascalia",
    "Show invisible characters": "Mostra caratteri invisibili",
    "Size": "Dimensione carattere",
    "Solid": "Pieno",
    "Source": "Fonte",
    "Source code": "Codice sorgente",
    "Special Character": "Carattere Speciale",
    "Special character...": "Carattere speciale...",
    "Split cell": "Dividi la cella",
    "Square": "Quadrato",
    "Start list at number": "La lista inizia con il numero",
    "Strikethrough": "Barrato",
    "Style": "Stile",
    "Subscript": "Pedice",
    "Superscript": "Apice",
    "Switch to or from fullscreen mode": "Attiva/disattiva la modalit\xe0 schermo intero",
    "Symbols": "Simboli",
    "System Font": "Carattere di sistema",
    "Table": "Tabella",
    "Table caption": "Titolo tabella",
    "Table properties": "Propriet\xe0 della tabella",
    "Table styles": "Stili tabella",
    "Template": "Modello",
    "Templates": "Modelli",
    "Text": "Testo",
    "Text color": "Colore testo",
    "Text color {0}": "Colore del testo {0}",
    "Text to display": "Testo da visualizzare",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "L'URL inserito sembra essere un indirizzo email. Si vuole aggiungere il necessario prefisso mailto:?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "L'URL inserito sembra essere un collegamento esterno. Si vuole aggiungere il necessario prefisso http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "L'URL che hai inserito sembra essere un collegamento esterno. Vuoi aggiungere il prefisso https:// necessario?",
    "Title": "Titolo",
    "To open the popup, press Shift+Enter": "Per aprire il popup, premere Shift+Invio",
    "Toggle accordion": "Toggle accordion",
    "Tools": "Strumenti",
    "Top": "In alto",
    "Travel and Places": "Viaggi e luoghi",
    "Turquoise": "Turchese",
    "Underline": "Sottolineato",
    "Undo": "Annulla",
    "Upload": "Carica",
    "Uploading image": "Caricamento immagine",
    "Upper Alpha": "Alfabetico maiuscolo",
    "Upper Roman": "Romano maiuscolo",
    "Url": "URL",
    "User Defined": "Definito dall'utente",
    "Valid": "Valido",
    "Version": "Versione",
    "Vertical align": "Allineamento verticale",
    "Vertical space": "Spazio verticale",
    "View": "Visualizza",
    "Visual aids": "Aiuti visivi",
    "Warn": "Avviso",
    "White": "Bianco",
    "Width": "Larghezza",
    "Word count": "Conteggio parole",
    "Words": "Parole",
    "Words: {0}": "Parole: {0}",
    "Yellow": "Giallo",
    "Yes": "S\xec",
    "You are using {0}": "Si sta utilizzando {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Ci sono modifiche non salvate, si \xe8 sicuro di volere uscire?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Il browser non supporta l'accesso diretto alla cartella degli appunti. Usare i tasti di scelta rapida Ctrl+X/C/V.",
    "alignment": "allineamento",
    "austral sign": "simbolo dell'austral",
    "cedi sign": "simbolo del cedi",
    "colon sign": "simbolo del col\xf3n",
    "cruzeiro sign": "simbolo del cruzeiro",
    "currency sign": "simbolo di valuta",
    "dollar sign": "simbolo del dollaro",
    "dong sign": "simbolo del dong",
    "drachma sign": "simbolo della dracma",
    "euro-currency sign": "simbolo dell'euro",
    "example": "esempio",
    "formatting": "formattazione",
    "french franc sign": "simbolo del franco francese",
    "german penny symbol": "simbolo del pfennig tedesco",
    "guarani sign": "simbolo del guaran\xec",
    "history": "cronologia",
    "hryvnia sign": "simbolo della hryvnia",
    "indentation": "indentazione",
    "indian rupee sign": "simbolo della rup\xeca indiana",
    "kip sign": "simbolo del kip",
    "lira sign": "simbolo della lira",
    "livre tournois sign": "simbolo della lira di Tours",
    "manat sign": "simbolo del manat",
    "mill sign": "simbolo del mill",
    "naira sign": "simbolo della naira",
    "new sheqel sign": "simbolo del nuovo shekel",
    "nordic mark sign": "simbolo del marco nordico",
    "peseta sign": "simbolo della peseta",
    "peso sign": "simbolo del peso",
    "ruble sign": "simbolo del rublo",
    "rupee sign": "simbolo della rup\xeca",
    "spesmilo sign": "simbolo dello spesmilo",
    "styles": "stili",
    "tenge sign": "simbolo del tenge",
    "tugrik sign": "simbolo del tugrik",
    "turkish lira sign": "simbolo della lira turca",
    "won sign": "simbolo del won",
    "yen character": "simbolo dello yen",
    "yen/yuan character variant one": "simbolo yen/yuan variante uno",
    "yuan character": "simbolo dello yuan",
    "yuan character, in hong kong and taiwan": "simbolo dello yuan, Hong Kong e Taiwan",
    "{0} characters": "{0} caratteri",
    "{0} columns, {1} rows": "{0} colonne, {1} righe",
    "{0} words": "{0} parole"
});